import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import CardBillListStore from '../card-bill-list/card-bill-list-store';
import CusEntInfoStore from './corp-info-store';
import CusEntInsertPopup from './cusEnt-insert-popup';

const CusEntInsertPopupContainer = () => {
  // console.log('CardBillAccountInfoPopupContainer Load');

  const { visibleCusEntInsertPopup } = CusEntInfoStore;
  const [ cusEntInsertInfo, setCusEntInsertInfo ] = useState({});
  const { bankList, accountTypeList, selectedDong } = CardBillListStore;

  const [ textBoxValue, setTextBoxValue ] = useState('');
  const [ copyLineNumberList, setCopyLineNumberList ] = useState([]);
  const [ notifyMsg, setNotifyMsg ] = useState();

  const [ isOpened, setIsOpened ] = useState(false);

  useEffect(() => {
    // console.log('CardBillAccountInfoPopupContainer > useEffect()');
    CardBillListStore.getBankList();
    CardBillListStore.getAccountTypeList();

    if (visibleCusEntInsertPopup) {
      setCusEntInsertInfo({
          cusEntName: '',     // 업소명
          // dongCode: '',       // 일반주소
          dongName: '',
          poiName: '',        // 상세주소
          memo: '',           // 메모
          webID: '',          // 웹 아이디
          webPassword: '',    // 웹 비밀번호
          accountType: accountTypeList[0].Code,    // 정산타입
          commission: '0',     // 콜당금액
          minCompleteCnt: '1', // 최소콜수
          bankCode: '',       // 은행코드
          accountNo: '',      // 계좌번호
          bankOwnerName: '',  // 예금주
          lineNumber: '',
      });
      setCopyLineNumberList([]);
    };
  }, [ visibleCusEntInsertPopup ]);

  const onValueChanged = useCallback((name, e) => {
    const { value } = e;
    
    setCusEntInsertInfo((cusEntInsertInfo) => ({
      ...cusEntInsertInfo,
      [name]: value,
    }));
  }, []);

  const onValueChangedTextBox = useCallback((e) => {
    setTextBoxValue(e.value);
  });

  const onClickInsert = () => {
    if (textBoxValue.length > 0) {
      // 텍스트박스의 값이 리스트에 추가되도록 로직 작성
      const addLineNumber = { lineNumber: textBoxValue };

      const lineNumber = copyLineNumberList.map((data) => data.lineNumber).join(',');
      const isValidLineNumber = lineNumber.includes(textBoxValue);

      if (!isValidLineNumber) {
        setCopyLineNumberList([ ...copyLineNumberList, addLineNumber ]);
      } else {
        setNotifyMsg('중복되거나 허용되지 않는 번호가 있습니다.');
      }
      // 텍스트박스 비우기
      setTextBoxValue('');
    } else {
      setNotifyMsg('전화번호를 입력해주시기 바랍니다.');
      setTextBoxValue('');
    }
  };

  const onClickSave = useCallback(async () => {
    if (cusEntInsertInfo.cusEntName === '' && copyLineNumberList.length === 0){
      setNotifyMsg('업소명과 전화번호는 필수 입력 사항입니다.');
      return;
    } 
    if (cusEntInsertInfo.cusEntName === '') {
      setNotifyMsg('업소명은 필수 입력 사항입니다.');
      return;
    } 
    if (copyLineNumberList.length === 0){
      setNotifyMsg('전화번호는 필수 입력 사항입니다.');
      return;
    } 
    if (cusEntInsertInfo.cusEntName !== '' && copyLineNumberList.length > 0) {
      setNotifyMsg('');

      const lineNumber = copyLineNumberList.map((data) => data.lineNumber).join(',');
  
      setCusEntInsertInfo((cusEntInsertInfo) => ({
          ...cusEntInsertInfo,
          lineNumber: lineNumber,
      }));
      
      // setCusEntInsertInfo({ ...cusEntInsertInfo, lineNumber: lineNumber});

      console.log(cusEntInsertInfo.lineNumber);
    }
  }, [ cusEntInsertInfo, copyLineNumberList ]);

  const onChange = (e) => {
    setIsOpened(true);
  }

  if (!cusEntInsertInfo) {
    return;
  }

  return (
    <CusEntInsertPopup
      onValueChanged={onValueChanged}
      onClickSave={onClickSave}
      onHiding={() => CusEntInfoStore.setVisibleCusEntInsertPopup(false)}
      cusEntInsertInfo={cusEntInsertInfo}
      bankList={bankList}
      visibleCusEntInsertPopup={visibleCusEntInsertPopup}
      onClickInsert={onClickInsert}
      textBoxValue={textBoxValue}
      onValueChangedTextBox={onValueChangedTextBox}
      lineNumberList={copyLineNumberList}
      notifyMsg={notifyMsg}
      accountTypeList={accountTypeList}
      selectedDong={selectedDong}
      isOpened={isOpened}
      onChange={onChange}
    />
  );
};

export default React.memo(observer(CusEntInsertPopupContainer));